var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _path, _path2, _path3, _path4, _path5, _path6, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _g, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassportBad2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3752_129233)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 13.374,
    width: 1.06653,
    height: 7.46567,
    fill: "#C8253C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 14.4404,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(-90 5.90625 14.4404)",
    fill: "#C8253C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 13.374,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(90 117.359 13.374)",
    fill: "#C8253C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.289,
    y: 13.374,
    width: 1.06653,
    height: 7.46567,
    fill: "#C8253C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 110.962,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(-90 5.90625 110.962)",
    fill: "#C8253C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 110.962,
    width: 1.06653,
    height: 7.46567,
    transform: "rotate(-180 117.359 110.962)",
    fill: "#C8253C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.97656,
    y: 110.962,
    width: 1.06653,
    height: 7.46567,
    transform: "rotate(-180 6.97656 110.962)",
    fill: "#C8253C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 109.895,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(90 117.359 109.895)",
    fill: "#C8253C"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 70.8601,
    y: 88.5711,
    width: 35.4282,
    height: 35.4282
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.48px)",
      clipPath: "url(#bgblur_1_3752_129233_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 2.95238,
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619,
    fill: "#DF2B44",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5751,
    cy: 106.285,
    r: 11.8095,
    fill: "#DF2B44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2998 101.014C92.8488 100.465 93.7391 100.465 94.2881 101.014C94.8371 101.563 94.837 102.453 94.2881 103.002L90.7832 106.507L94.2881 110.012C94.837 110.561 94.8371 111.451 94.2881 112C93.7391 112.549 92.8488 112.549 92.2998 112L88.7949 108.495L85.29 112C84.741 112.549 83.8507 112.549 83.3018 112C82.7529 111.451 82.7529 110.561 83.3018 110.012L86.8066 106.507L83.3018 103.002C82.753 102.453 82.7528 101.563 83.3018 101.014C83.8507 100.465 84.741 100.465 85.29 101.014L88.7949 104.519L92.2998 101.014ZM94.0752 101.775L94.0762 101.776L94.0752 101.775ZM84.6748 101.286H84.6758H84.6748Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.543 54C105.543 56.9399 103.16 59.3232 100.22 59.3232H24.8076C21.8677 59.3232 19.4845 56.9399 19.4844 54V-15.2021H100.22C103.16 -15.2021 105.543 -12.8189 105.543 -9.87891V54Z",
    fill: "#C9D1DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7109 -11.6533C17.7109 -14.5933 20.0942 -16.9766 23.0342 -16.9766H98.4468C101.387 -16.9766 103.77 -14.5933 103.77 -11.6533V22.0605H17.7109V-11.6533Z",
    fill: "url(#paint0_linear_3752_129233)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7429 39.8051C46.2882 39.8051 34.5703 28.0872 34.5703 13.6325C34.5703 -0.822189 46.2882 -12.54 60.7429 -12.54C75.1977 -12.54 86.9156 -0.822189 86.9156 13.6325C86.9156 28.0872 75.1977 39.8051 60.7429 39.8051ZM60.7429 -7.30553C60.2515 -7.30553 59.7641 -7.2886 59.2811 -7.25529C59.1916 -7.14191 59.0951 -7.01689 58.9926 -6.88023C58.3399 -6.00989 57.4443 -4.67068 56.5407 -2.86349C55.7281 -1.23817 54.9065 0.770081 54.2492 3.16349H67.2367C66.5794 0.770081 65.7578 -1.23817 64.9452 -2.86349C64.0415 -4.67068 63.146 -6.00989 62.4932 -6.88023C62.3907 -7.01689 62.2943 -7.14191 62.2048 -7.25529C61.7218 -7.2886 61.2344 -7.30553 60.7429 -7.30553ZM47.6566 13.6325C47.6566 11.7881 47.7592 10.0432 47.9421 8.398H40.4645C40.0339 10.0711 39.8048 11.825 39.8048 13.6325C39.8048 15.44 40.0339 17.194 40.4645 18.867H47.9421C47.7592 17.2219 47.6566 15.4769 47.6566 13.6325ZM48.8467 24.1015H42.606C44.7581 27.8218 48.0219 30.8185 51.9433 32.6372L51.8588 32.4695C50.7447 30.2411 49.6426 27.4507 48.8467 24.1015ZM54.2492 24.1015L67.2367 24.1015C66.5794 26.4949 65.7578 28.5032 64.9452 30.1285C64.0415 31.9357 63.146 33.2749 62.4932 34.1452C62.3907 34.2819 62.2943 34.4069 62.2048 34.5203C61.7218 34.5536 61.2344 34.5705 60.7429 34.5705C60.2515 34.5705 59.7641 34.5536 59.2811 34.5203C59.1916 34.4069 59.0951 34.2819 58.9926 34.1452C58.3399 33.2749 57.4443 31.9357 56.5407 30.1285C55.7281 28.5032 54.9065 26.4949 54.2492 24.1015ZM68.2727 18.867L53.2132 18.867C53.0086 17.2433 52.8912 15.4986 52.8912 13.6325C52.8912 11.7664 53.0086 10.0217 53.2132 8.398H68.2727C68.4773 10.0217 68.5947 11.7664 68.5947 13.6325C68.5947 15.4986 68.4773 17.2433 68.2727 18.867ZM72.6392 24.1015C71.8433 27.4507 70.7412 30.2411 69.6271 32.4695L69.5426 32.6372C73.464 30.8185 76.7278 27.8218 78.8799 24.1015H72.6392ZM81.0214 18.867H73.5438C73.7267 17.2219 73.8293 15.4769 73.8293 13.6325C73.8293 11.7881 73.7267 10.0432 73.5438 8.398H81.0214C81.452 10.0711 81.681 11.825 81.681 13.6325C81.681 15.44 81.452 17.194 81.0214 18.867ZM51.8588 -5.20443C50.7447 -2.97613 49.6426 -0.185654 48.8467 3.16349H42.606C44.7581 -0.556786 48.0219 -3.55345 51.9433 -5.37218L51.8588 -5.20443ZM69.5426 -5.37218C73.464 -3.55345 76.7278 -0.556787 78.8799 3.16349H72.6392C71.8433 -0.185657 70.7412 -2.97613 69.6271 -5.20443L69.5426 -5.37218Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7109 22.0605H103.77V52.2255C103.77 55.1655 101.387 57.5488 98.4468 57.5488H23.0342C20.0942 57.5488 17.7109 55.1655 17.7109 52.2255V22.0605Z",
    fill: "url(#paint1_linear_3752_129233)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8849 52.4303C38.6699 51.0494 39.4061 48.0599 39.2321 45.9708C39.0845 44.1991 37.7793 44.0524 36.2174 44.5885C33.7908 45.4214 31.1339 46.848 30.6331 49.4829C30.2633 51.429 29.9959 54.6774 32.5576 55.3025C34.7492 55.8372 36.4126 52.8938 36.2619 51.0642C36.1844 50.1233 34.9048 50.5279 34.7602 51.2525C34.3624 53.2459 36.6684 54.2178 38.4089 53.9578C39.2893 53.8263 39.9627 53.2928 40.478 52.6186C40.5829 52.4813 40.7956 51.8522 41.0564 52.0323C41.7792 52.5316 42.5428 52.8668 43.2924 53.3017",
    stroke: "#C4CDD5",
    strokeWidth: 0.613996,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 58.3657,
    height: 2.21804,
    rx: 0.887207,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 43.1328 48.6768)",
    fill: "#83888E",
    fillOpacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 63.0118,
    height: 2.21804,
    rx: 0.887207,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 38.4922 52.6689)",
    fill: "#83888E",
    fillOpacity: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11.4081,
    height: 0.996006,
    rx: 0.498003,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 43.5156 29.6016)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 15.2716,
    height: 0.996006,
    rx: 0.498003,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 43.5156 34.9248)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 23.2257,
    height: 0.996006,
    rx: 0.498003,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 43.5156 43.3535)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 4.75726,
    height: 0.996006,
    rx: 0.498003,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 43.4375 31.7285)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 8.60479,
    height: 0.996006,
    rx: 0.498003,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 43.4375 37.0518)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 23.4844,
    height: 0.996006,
    rx: 0.498003,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 43.4375 45.4795)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2578,
    y: 29.1582,
    width: 17.7442,
    height: 17.7441,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3752_129233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 29,
    width: 18,
    height: 18
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2578,
    y: 29.1582,
    width: 17.7442,
    height: 17.7441,
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3752_129233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1834 33.9416L26.0571 34.9577C25.8027 37.0037 27.4 38.81 29.4618 38.81C29.8546 38.81 30.2448 38.8777 30.6147 39.0102C32.841 39.8078 35.185 38.1576 35.185 35.7928V34.5934C35.185 34.052 35.0094 33.5253 34.6846 33.0922L34.0209 32.207C33.5019 31.515 32.8187 30.9632 32.0329 30.6015C30.68 29.9788 29.0752 30.4222 28.2338 31.6511L28.0174 31.9672C27.0447 32.1618 26.3058 32.9572 26.1834 33.9416Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.875 51.6812V47.2346C22.875 44.7674 24.8294 42.7436 27.2952 42.6576L28.5081 42.6152H31.9452L33.0587 42.6548C35.5564 42.7434 37.566 44.7377 37.6738 47.2346V51.6812L30.1931 53.1317L22.875 51.6812Z",
    fill: "#BBC3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5367 42.3249V40.8103C28.5367 40.599 28.7079 40.4277 28.9192 40.4277H31.4057C31.617 40.4277 31.7883 40.599 31.7883 40.8103V42.3249C31.7883 42.3977 31.8091 42.4691 31.8482 42.5305L32.3306 43.2888C32.4137 43.4193 32.4578 43.5708 32.4578 43.7255C32.4578 43.9489 32.3659 44.1625 32.2037 44.3161L31.7432 44.7522C30.905 45.546 29.6017 45.5754 28.7285 44.8203L28.1384 44.31C27.9662 44.1611 27.8672 43.9446 27.8672 43.7169C27.8672 43.5678 27.9097 43.4218 27.9897 43.296L28.4768 42.5305C28.5159 42.4691 28.5367 42.3977 28.5367 42.3249Z",
    fill: "#A2ABB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3251 37.4964L34.0505 38.0915C33.9541 38.3005 33.7756 38.4602 33.5573 38.533C33.4092 38.5824 33.2875 38.6898 33.2202 38.8306L32.7131 39.8909C32.4315 40.48 31.9291 40.9343 31.3148 41.1555L31.1513 41.2143C30.3313 41.5096 29.4339 41.5096 28.6139 41.2143C27.9139 40.9623 27.3889 40.3734 27.2185 39.6492L26.9306 38.4256C26.7959 37.8528 26.7744 37.2592 26.8673 36.6781L26.9267 36.3067C27.0474 35.5528 27.3015 34.8264 27.6771 34.1617L28.2023 33.2323C28.2796 33.0955 28.4633 33.0647 28.5811 33.1686L29.9171 34.3476C29.9574 34.3832 30.0048 34.4099 30.0561 34.4259L31.5084 34.8798L32.0527 35.109C32.8324 35.4374 33.3589 36.1791 33.4117 37.0235C33.4145 37.068 33.4735 37.0813 33.4951 37.0424L33.6837 36.7029C33.7821 36.5257 34.0333 36.5155 34.1457 36.6842L34.2772 36.8814C34.399 37.0641 34.4171 37.297 34.3251 37.4964Z",
    fill: "url(#paint2_linear_3752_129233)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.7109,
    y1: 21.8387,
    x2: 103.77,
    y2: 21.8387,
    stroke: "black",
    strokeWidth: 0.443603
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_3752_129233_clip_path",
    transform: "translate(-70.8601 -88.5711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3752_129233",
    x1: 54.4227,
    y1: -14.9174,
    x2: 54.8894,
    y2: 23.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3752_129233",
    x1: 62.432,
    y1: 56.8069,
    x2: 61.2568,
    y2: 22.6027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3752_129233",
    x1: 28.3614,
    y1: 34.3142,
    x2: 32.075,
    y2: 40.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB4BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3752_129233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportBad2);
export default __webpack_public_path__ + "static/media/PassportBad2.cf01d8ffb375bf2b215fee1017f7e801.svg";
export { ForwardRef as ReactComponent };